import { ToggleSwitch } from '@/core/ToggleSwitch.atom';

import { sqWorkbenchStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';
import { useSearchDatasources } from '@/search/search.store';
import { fcGear } from '@seeqdev/icons/seeq';
import { Icon } from '@seeqdev/qomponents';

export interface DatasourcePreferencesToggleProps {
  on: boolean;
  onChange: () => void;
  formattedLabel: string;
  onClick: () => void;
  extraClassNames?: string;
}

export const DatasourcePreferencesToggle = ({
  on,
  onChange,
  formattedLabel,
  onClick,
  extraClassNames,
}: DatasourcePreferencesToggleProps) => {
  const datasources = useSearchDatasources();
  const { includeNewDatasources, userDatasources } = useFlux(sqWorkbenchStore);

  const userHasCustomizedDatasourcePreferences =
    (userDatasources.length > 1 && includeNewDatasources) ||
    (userDatasources.length < datasources.length - 1 && !includeNewDatasources);
  return (
    <div
      data-testid="datasourcePreferencesToggleAndGear"
      className={`flexColumnContainer tw:items-center tw:justify-end ${extraClassNames}`}>
      {userHasCustomizedDatasourcePreferences && (
        <ToggleSwitch
          testId="datasourcePreferencesToggle"
          isOn={on}
          onChange={onChange}
          formattedLabel={<span className="force-link-color">{formattedLabel}</span>}
        />
      )}
      <div onClick={onClick} className="cursorPointer tw:mb-sq-5 tw:ml-sq-7">
        <Icon icon={fcGear} large={true} />
      </div>
    </div>
  );
};
